let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4f6ey")).then(() => parcelRequire('fjiLk'));